<template>
	<button @click="handleClick" class="tab--link" :class="{ active }">
		<slot></slot>
	</button>
</template>

<script setup>
import { inject } from '@vue/runtime-core'

const props = defineProps({
	target: {
		type: String,
		required: true
	},
	active: {
		type: Boolean,
		default: false
	},
	path: {
		type: Array,
		default: () => []
	},
	muted: {
		type: Boolean,
		default: false
	}
})

const emit = defineEmits(['tab:click'])

const amplitude = inject('amplitude')

const handleClick = () => {
	if (!props.muted) {
		amplitude.logEvent('ButtonClick', {
			title: props.target + 'Button',
			path: props.path
		})
	}

	emit('tab:click', props.target)
}
</script>

<style scoped lang="scss">
.tab--link {
	background-color: transparent;
	box-shadow: none;
	text-shadow: none;
	padding: 0;
	border: 1px solid #e9eaf2;
	border-radius: 0.5rem;
	padding: 0.86rem 0;
	transition: border-color 0.3s, box-shadow 0.6s;

	&::v-deep img {
		max-height: 1.3rem;
		max-width: 90%;
		display: block;
		margin: auto;
	}

	&.active {
		border: 1px solid #7d8bf7;
		box-shadow: inset 0 0 0 0.5px #7d8bf7;
	}
}
</style>
